import * as yup from 'yup';
// import {
//   LocationModel,
//   TimeSlotModel,
// } from '.';

export interface TimeFrameModel {
  _id?: string;
  startTime?: string;
  endTime?: string;
  name?: string;
  status?: boolean;

  // General fields
  createdBy?: string;
  createdDate?: string;
  modifiedBy?: string;
  modifiedDate?: string;
}

export interface TimeFrameListModel {
  status: string;
  currentPage: number;
  pageSize: number;
  sort: number;
}

export const TimeFrameSchema = yup.object().shape({
  title: yup.string().required('Title is Required.'),
  location: yup.object().shape({
          city: yup.string().required('City Required'),
          state: yup.string().required('State Required'),
          address: yup.string().required('Address Required'),
          unit: yup.string().required('Unit Required'),
          latitude: yup.string().required('Latitude Required'),
          longitude: yup.string().required('Longitude Required'),
      })
    .required('Must have Location'),
  recurrence: yup.boolean().required('Recurrence is Required.'),
  taskDateTime: yup.string().required('Date time is Required.'),
  type: yup.number().required('type is Required.'),
  timeSlots: yup
    .array()
    .of(
      yup.object().shape({
        startDateTime: yup.string().required('Start Date Time is Required'),
        endDateTime: yup.string().required('End Date Time is Required'),
        quantity: yup.number().required('Quantity is Required'),
        occupied: yup.number().required('Occupied is Required'),
      }),
    )
    .when('type', {
      is: (val: number) => val === 1,
      then: (schema) => schema.required('Must have Time Slots'),
      otherwise: (schema) => schema.optional(),
    }),
    
  // timeSlots: yup
  //   .array()
  //   .of(
  //     yup.object().shape({
  //       startDateTime: yup.string().required('Required'),
  //       endDateTime: yup.string().required('Required'),
  //       quantity: yup.number().required('Required'),
  //       occupied: yup.number().required('Required'),
  //     }),
  //   )
  //   .required('Must have Time Slots'),
    // .min(1, 'Minimum of 1 Time Slot'),
  // maxCapacity: yup.number().required('Participant Count is Required.').positive('Participant Count must be positive number'),
  // isVirtual: yup.boolean().required('Online Activity Option is Required.'),
  // isasd: yup.string().nullable(),
  // contacts: yup
  //   .array()
  //   .of(
  //     yup.object().shape({
  //       name: yup.string().required('Required'), // these constraints take precedence
  //       contact: yup.string().required('Required'), // these constraints take precedence
  //       email: yup.string().required('Required'), // these constraints take precedence
  //     })
  //   )
  //   .required('Must have Contacts') // these constraints are shown if and only if inner constraints are satisfied
  //   .min(1, 'Minimum of 1 contact'),
});
